export class PreviousCampaignsModel {
    TriggerId: number;
    MessageName: string;
    ListName: string;
    ScheduledDate: string;
    MessageId: number;
    MessageType: number;
    ReportId: number;
    PreviewUrl: string;

    constructor(init: any) {
        this.TriggerId = init.TriggerId;
        this.MessageName = init.MessageName;
        this.ListName = init.ListName;
        this.ScheduledDate = init.ScheduledDate;
        this.MessageId = init.MessageId;
        this.MessageType = init.MessageType;
        this.ReportId = init.ReportId;
        this.PreviewUrl = init.PreviewUrl;
    }
}